// POWR Devotional Character Images
// Premium HD images from Unsplash for each biblical character
// All images are high-resolution, professional, and cinematic quality

export const DEVOTIONAL_IMAGES = {
  // David - Disrupting the Giant (Strategy)
  // Epic mountain landscape with dramatic golden hour sunlight
  david: "https://images.unsplash.com/photo-1753010837210-06dfb1ffc5d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxlcGljJTIwbW91bnRhaW4lMjBsYW5kc2NhcGUlMjBkcmFtYXRpYyUyMHN1bnNldCUyMGdvbGRlbiUyMGhvdXIlMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzc1MzA4MTcwfDA&ixlib=rb-4.1.0&q=85",
  
  // Moses - When the Only Way Out Is Through (Leadership)
  // Dramatic sunbeams breaking through stormy clouds - divine light
  moses: "https://images.unsplash.com/photo-1745751076802-bc33cfc36a4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxkaXZpbmUlMjBzdW5iZWFtcyUyMHJheXMlMjBjbG91ZHMlMjBkcmFtYXRpYyUyMHNwaXJpdHVhbCUyMGVwaWMlMjBza3l8ZW58MHx8fHwxNzc1MzA4MTg5fDA&ixlib=rb-4.1.0&q=85",
  
  // Daniel - Integrity Under Pressure (Purpose)
  // Stunning lion emerging from shadows - dramatic wildlife portrait
  daniel: "https://images.unsplash.com/photo-1668448388988-a901c54d954e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxsaW9uJTIwcG9ydHJhaXQlMjBkcmFtYXRpYyUyMGRhcmslMjBtb29keSUyMHByb2Zlc3Npb25hbCUyMHdpbGRsaWZlfGVufDB8fHx8MTc3NTMwODE3OXww&ixlib=rb-4.1.0&q=85",
  
  // Joseph - The Long Play (Vision)
  // Egyptian pyramids at dramatic golden sunset
  joseph: "https://images.unsplash.com/photo-1746310783422-16df7622e7c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxlZ3lwdGlhbiUyMHB5cmFtaWRzJTIwYW5jaWVudCUyMGRyYW1hdGljJTIwc3Vuc2V0JTIwZ29sZGVufGVufDB8fHx8MTc3NTMwODE5Mnww&ixlib=rb-4.1.0&q=85",
  
  // Nehemiah - Building While They Talk (Legacy)
  // Ancient Jerusalem stone walls with dramatic sky
  nehemiah: "https://images.unsplash.com/photo-1767873542711-3b635b5c3b77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxhbmNpZW50JTIwamVydXNhbGVtJTIwc3RvbmUlMjB3YWxscyUyMGRyYW1hdGljJTIwc2t5JTIwaGlzdG9yaWNhbHxlbnwwfHx8fDE3NzUzMDgxODF8MA&ixlib=rb-4.1.0&q=85",
  
  // Prodigal Son - Coming Back Stronger (Resilience)
  // Cinematic desert road at sunset - journey home
  prodigal: "https://images.unsplash.com/photo-1751877055832-a4d8848ad312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxkZXNlcnQlMjByb2FkJTIwam91cm5leSUyMHNpbGhvdWV0dGUlMjBzdW5zZXQlMjBkcmFtYXRpYyUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3NzUzMDgxODB8MA&ixlib=rb-4.1.0&q=85",
  
  // Paul - The Pivot (Purpose)
  // Dramatic divine light rays through dark clouds
  paul: "https://images.unsplash.com/photo-1536259199821-24af7564fe9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxkaXZpbmUlMjBzdW5iZWFtcyUyMHJheXMlMjBjbG91ZHMlMjBkcmFtYXRpYyUyMHNwaXJpdHVhbCUyMGVwaWMlMjBza3l8ZW58MHx8fHwxNzc1MzA4MTg5fDA&ixlib=rb-4.1.0&q=85",
  
  // Esther - Strategic Influence (Strategy)
  // Ornate golden temple palace with royal architecture
  esther: "https://images.unsplash.com/photo-1764611837011-a6177949658f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxhbmNpZW50JTIwdGVtcGxlJTIwcGFsYWNlJTIwZ29sZGVuJTIwYXJjaGl0ZWN0dXJlJTIwZHJhbWF0aWMlMjBsaWdodGluZyUyMGx1eHVyeXxlbnwwfHx8fDE3NzUzMDgxNzF8MA&ixlib=rb-4.1.0&q=85",
  
  // Noah - Building What Nobody Understands (Vision)
  // Historic wooden Viking ship with dramatic stormy backdrop
  noah: "https://images.pexels.com/photos/7931169/pexels-photo-7931169.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  
  // Peter - Step Into the Impossible (Resilience)
  // Epic dramatic stormy ocean with powerful waves
  peter: "https://images.unsplash.com/photo-1774357724425-3d5c3501b7ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxkcmFtYXRpYyUyMGNpbmVtYXRpYyUyMHN0b3JteSUyMHNreSUyMG9jZWFuJTIwd2F2ZXMlMjBwb3dlcmZ1bCUyMGVwaWN8ZW58MHx8fHwxNzc1MzA4MTY4fDA&ixlib=rb-4.1.0&q=85",
  
  // Good Samaritan - Lead Beyond Your Circle (Leadership)
  // Powerful black and white hands reaching toward each other
  samaritan: "https://images.unsplash.com/photo-1579098892839-a154f0f4f8d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxoYW5kcyUyMHJlYWNoaW5nJTIwaGVscGluZyUyMGRyYW1hdGljJTIwZGFyayUyMGVtb3Rpb25hbCUyMHBvd2VyZnVsfGVufDB8fHx8MTc3NTMwODE5MXww&ixlib=rb-4.1.0&q=85",
  
  // Solomon - The Ask That Changed Everything (Strategy)
  // Magnificent royal golden crown - wisdom and power
  solomon: "https://images.unsplash.com/photo-1742189415527-9149c0c546c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxyb3lhbCUyMGNyb3duJTIwZ29sZCUyMHRocm9uZSUyMGx1eHVyeSUyMG9wdWxlbnQlMjBkcmFtYXRpY3xlbnwwfHx8fDE3NzUzMDgxOTB8MA&ixlib=rb-4.1.0&q=85"
};

// Helper function to get image by character ID
export const getDevotionalImage = (characterId) => {
  return DEVOTIONAL_IMAGES[characterId] || DEVOTIONAL_IMAGES.david;
};

export default DEVOTIONAL_IMAGES;
